import { render, staticRenderFns } from "./ResultDetails.html?vue&type=template&id=e5c4dda0&"
import script from "./ResultDetails.vue?vue&type=script&lang=ts&"
export * from "./ResultDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports